export default __webpack_public_path__ + "static/media/logo.6eb52598.svg";